import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"

export default (props) => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>
            POST /users/me/spaces/{"{"}spaceId{"}"}/hide
          </h1>
        </div>
        <p>Hide a specified space from the viewer (<b><i>Me</i></b>) list of spaces.
        <p>
          <b>
            Note: 
          </b>
          <p>
            <ul>                    
              <li>All contents for the space identified by spaceId is preserved and visible to the other parties.</li>
              <li>The other parties will still see this Space in their list of direct/recent spaces.</li>                            
            </ul>
          </p>
        </p>
 
        <br/>Read <Link to="/tutorials/createanewspace#section12">
              Manage Space 
              </Link> tutorial to lean how to un-hide a space.
        </p>
        
        <h2>Body Parameters</h2>
        <p>None.</p>
        <h2>Authentication</h2>
        <p>JwtAuthenticator, Oauth2Authenticator, AnonymousAuthenticator</p>
        <h2>Authorization</h2>
        <p>isInviteCreatorByParams</p>
        <h2>Example Request</h2>
        <h4>URL</h4>
        <pre className="nginx">
          POST https://spacesapis.avayacloud.com/api/users/me/spaces/{"{"}spaceId{"}"}/hide
        </pre>
        <h4>Headers</h4>
        <pre className="javascript">
          Authorization: "jwt
          eyJhbGciOiJSgzI1NiIsIdfgdfgnR5cCI6IkpXVhJ9.eyJ1c2VyX2lkX3NpZyI6ImxPWHphNzVzR3J3X0xwWEMyRGRMakhyYXJlWVhyTzFMdEZ1HZkhkOWNkTXciLCJwcm9kdWN0X3R5cGUiOiJhY2NvdW50cyIsImxhc3R1cGRhdGV0aW1lIjoiMjAxNy0wMS0zMFQxMzo1ODo0Ny4yMDYiLCJpc3MiOiJ6YW5nLmlvIiwicHVibGlja2V5aWQiOiJhZ3h6Zm05dVpYTnVZVEl3TVRSeUdnc1NEVWRLZDNSUWRXSnNhV05MWlhrdfgdWdJQ2dsUEtFakFvTSIsImV4cCI6MTQ5NTM5MTIwMywidXNlcl9pZCI6ImFneHpmbTl1WlhOdVlUSXdNVFJ5RVFzU0JGVnpaWElZZ0lEQXMtX25fUW9NIiwidmVyIjoiMi4wIn0.SqZpw1uPIebqW3qlDsm0-DWYFKEH0SgPwtD-tSESWOF-5hLkZMqJH28ooWux2S7s9riIew7pTVPnZpTgJa5zHcEAG0gXSEJVOqmpGp_4ufM8YtZoZMpBFjyAkwyAt-ILkGUYIo0GU5WyzMPLV8YLXfgdfgOgkE2MGGOajBkjPmC2Db3pA0D0M9k-21EL1gwWBC5YIq0PDAkgulegwl6khRmB8irJQ-dfg-d-KV9eYfFpsCdJhRGzSfqg"
        </pre>
        <p>Or</p>
        <pre className="javascript">
          Authorization: "bearer f746696f5de4528u128ae2f274eea253e8a7943a"
        </pre>
        <h2>Example Response</h2>
        {/* <p>
          Returns http status code 200 if successful and http error status
          otherwise.
        </p> */}
                <pre className="json">
        {`{
    "status": 4,
    "unread": false,
    "_id": "5f058c5682f82ea3fe050175",
    "targetId": "5f058c5682f82e7f05050174",
    "userId": "5ef9b678aa4a347af983c74c",
    "userType": "user",
    "lastAccess": "2020-07-17T08:52:42.942Z",
    "role": "admin",
    "targetType": "topic",
    "title": "Example name",
    "type": "group",
    "isPinned": false,
    "notification": false
}`} 
</pre>
        <h2>Socket Event</h2>
        <p>
          The Spaces-Server would send the following Socket event to the user. So, other apps would hide this space from the user's Spaces list.         
        </p>
        <pre className="javascript">
          var message = {"{"}                
            {"\n"}
            {"    "}sender: {"{"}
            {"\n"}
            {"        "}_id: '{"{"}senderId{"}"}',{"\n"}
            {"        "}type: 'user',{"\n"}
            {"        "}displayname: 'Sender display name'{"\n"}
            {"    "}
            {"}"},{"\n"}
            {"    "}category: 'topic.hidden',{"\n"}
            {"    "}topicId: '{"{"}spaceId{"}"}'{"\n"}
            {"}"};              
        </pre>
      </div>
    </div>
  </Layout>
)
